<template>
    <!-- <Breadcrumbs main="Setting" mains="Divisi Management" title="Divisi Management" /> -->
    <div class="container-fluid default-dashboard">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Divisi List</h5>
                    <button class="btn btn-primary" @click="openModal()">
                        <i class="fa fa-plus"></i> Add Divisi
                    </button>
                </div>
            </div>
            <div class="card-body">
                <DataTable
                    :headers="headers"
                    :items="divisis"
                    :loading="loading"
                    :total="total"
                    :params="params"
                    @update:params="updateParams"
                >
                    <template #item.actions="{ item }">
                        <button class="btn btn-sm btn-info me-2" @click="viewDivisi(item as Divisi)">
                            <i class="fa fa-eye"></i>
                        </button>
                        <button class="btn btn-sm btn-warning me-2" @click="editDivisi(item as Divisi)">
                            <i class="fa fa-edit"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" @click="deleteDivisi(item as Divisi)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>

    <div class="modal fade bd-example-modal-lg" id="divisiModal" tabindex="-1" ref="modalRef" aria-labelledby="divisiModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <h3 class="modal-header justify-content-center border-0">{{ modalTitle }}</h3>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="form-label col-form-label">Code</label>
                                <input v-model="form.code" type="text" class="form-control" required>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="form-label col-form-label">Name</label>
                                <input v-model="form.name" type="text" class="form-control" required>
                            </div>
                        </div>
                        <hr>
                        <div class="mb-2">
                            <label class="form-label col-form-label">DivisiTeams</label>
                            <div v-for="(account, idx) in form.divisiTeams" :key="account.ID ?? idx" class="border rounded p-2 mb-2">
                                <div class="row g-2">
                                    <div class="col-md-4">
                                        <input v-model="account.code" type="text" class="form-control" placeholder="DivisiTeam Number" required>
                                    </div>
                                    <div class="col-md-8">
                                        <input v-model="account.name" type="text" class="form-control" placeholder="DivisiTeam Name" required>
                                    </div>
                                    <div class="col-md-1 d-flex align-items-center">
                                        <button type="button" class="btn btn-danger btn-sm" @click="removeDivisiTeam(idx)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-success btn-sm mt-2" @click="addDivisiTeam">
                            <i class="fa fa-plus"></i> Add DivisiTeam
                        </button>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-danger" type="button" @click="closeModal">Cancel</button>
                        <button class="btn btn-primary" type="submit" @click="saveDivisi">Save</button>
                    </div>
            </div>
        </div>
    </div>


    <!-- View Divisi Modal -->
    <div class="modal fade" id="viewDivisiModal" tabindex="-1" ref="viewModalRef">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Divisi & DivisiTeam Information</h5>
                    <button type="button" class="btn-close" @click="closeViewModal"></button>
                </div>
                <div class="modal-body">
                    <div v-if="selectedDivisi">
                        <div class="mb-2"><strong>Code:</strong> {{ selectedDivisi.code }}</div>
                        <div class="mb-2"><strong>Divisi:</strong> {{ selectedDivisi.name }}</div>
                        <div>
                            <strong>DivisiTeams:</strong>
                            <ul v-if="selectedDivisi.divisiTeams && selectedDivisi.divisiTeams.length">
                                <li v-for="(account, idx) in selectedDivisi.divisiTeams" :key="account.ID ?? idx">
                                    <span>
                                        <strong>No:</strong> {{ account.code }},
                                        <strong>Nama:</strong> {{ account.name }},
                                    </span>
                                </li>
                            </ul>
                            <div v-else>
                                <em>No divisiTeams available.</em>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeViewModal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/Datatable.vue'
import { Modal } from 'bootstrap'

// {{ Define Divisi interface }}
interface Divisi {
    ID: number| null; // Allow null for new divisis
    code: string;
    name: string;
    divisiTeams?: DivisiTeam[]; // Optional for backward compatibility
}

// {{ Define DivisiTeam interface }}
interface DivisiTeam {
    ID: number | null;
    code: string;
    name: string;
}

const headers = [
    { text: 'Code', value: 'code' },
    { text: 'Name', value: 'name' },
    { text: 'Actions', value: 'actions' }
]

// {{ Apply types to refs and reactive objects }}
const divisis = ref<Divisi[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: ''
})

const modalTitle = ref('')
const form = reactive<Divisi>({
    ID: null,
    code: '',
    name: '',
    divisiTeams: []
})

// Add this data data array
const dataDivisis: Divisi[] = []
import * as master from "@/api/services/MasterRequest";

const fetchDivisis = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const resp = await master.postRequest("/divisi/list", {...params});
        dataDivisis.splice(0, dataDivisis.length);
        dataDivisis.push(...resp.data);

        // Filter based on search
        let filteredDivisis = [...dataDivisis]
        if (params.search) {
            const searchLower = params.search.toLowerCase()
            filteredDivisis = dataDivisis.filter(divisi =>
                divisi.code.toLowerCase().includes(searchLower) ||
                divisi.name.toLowerCase().includes(searchLower)
            )
        }

        // Calculate pagination
        const start = (params.page - 1) * params.size
        const end = start + params.size
        divisis.value = filteredDivisis.slice(start, end)
        total.value = filteredDivisis.length

    } catch (error) {
        toast.error('Failed to fetch divisis')
    }
    loading.value = false
}

// {{ Add type annotation for newParams }}
const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchDivisis()
}

const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly

// View modal state
const viewModalRef = ref<HTMLElement | null>(null)
let bsViewModal: any | null = null
const selectedDivisi = ref<Divisi | null>(null)

onMounted(() => {
    if (modalRef.value) { // Check if modalRef exists
        bsModal = new Modal(modalRef.value)
    }
    if (viewModalRef.value) {
        bsViewModal = new Modal(viewModalRef.value)
    }
})

const closeModal = () => {
    if (bsModal) { // Check if bsModal is initialized
        bsModal.hide()
    }
}

const saveDivisi = async () => {
    loading.value = true; // Indicate loading state
    try {
        // Simulate API call
        // await new Promise(resolve => setTimeout(resolve, 500));
        if (form.ID) {
            // Update existing divisi in data data
            await master.postRequest("/divisi/update", form).then((resp) => {
                if (resp.status === 200) {
                    toast.success('Divisi updated successfully');
                    closeModal();
                    fetchDivisis(); // Re-fetch to update the table view
                } else {
                    toast.error('Failed to update divisi');
                }
            }).catch((error) => {
                toast.error(error.message || 'Failed to update divisi');
            })
            // const index = dataDivisis.findIndex(r => r.ID === form.ID);
            // if (index !== -1) {
            //     dataDivisis[index] = { ...form }; // Update with new form data
            // }
        } else {
            // Add new divisi to data data
            await master.postRequest("/divisi/create", form).then((resp) => {
                if (resp.status === 200) {
                    toast.success('Divisi created successfully');
                    closeModal();
                    fetchDivisis(); // Re-fetch to update the table view
                } else {
                    toast.error('Failed to create divisi');
                }
            }).catch((error) => {
                toast.error(error.message || 'Failed to create divisi');
            })
        }
    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to save divisi');
    } finally {
        loading.value = false; // End loading state
    }
}

// {{ Define editDivisi function }}
const editDivisi = (divisi: Divisi) => {
    openModal(divisi); // Call openModal with the divisi data
}


// {{ Add type annotation for divisi parameter }}
const deleteDivisi = async (divisi: Divisi) => {
    if (!confirm('Are you sure you want to delete this divisi?')) return

    loading.value = true; // Indicate loading state
    try {
        // Simulate API call
        await master.postRequest("/divisi/delete", {ID: divisi.ID}).then((resp) => {
            if (resp.status === 200) {
                toast.success('Divisi deleted successfully');
                closeModal();
                fetchDivisis(); // Re-fetch to update the table view
            } else {
                toast.error('Failed to delete divisi');
            }
        })

    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to delete divisi');
    } finally {
        loading.value = false; // End loading state
    }
}

// Add account management methods
const addDivisiTeam = () => {
    form.divisiTeams = form.divisiTeams || [];
    form.divisiTeams.push({
        ID: null,
        code: '',
        name: '',
    });
};

const removeDivisiTeam = (idx: number) => {
    if (form.divisiTeams) form.divisiTeams.splice(idx, 1);
};

// Update openModal to ensure divisiTeams array exists
const openModal = (divisi: Divisi | null = null) => {
    if (divisi) {
        modalTitle.value = 'Edit Divisi'
        Object.assign(form, divisi);
        // Deep copy divisiTeams to avoid mutating dataDivisis directly
        form.divisiTeams = divisi.divisiTeams ? divisi.divisiTeams.map(acc => ({ ...acc })) : [];
    } else {
        modalTitle.value = 'Create Divisi'
        form.ID = null
        form.code = ''
        form.name = ''
        form.divisiTeams = []
    }
    if (bsModal) {
        bsModal.show()
    }
}

// View modal logic
const viewDivisi = (divisi: Divisi) => {
    selectedDivisi.value = divisi
    if (!bsViewModal && viewModalRef.value) {
        bsViewModal = new Modal(viewModalRef.value)
    }
    if (bsViewModal) {
        bsViewModal.show()
    }
}

const closeViewModal = () => {
    if (bsViewModal) {
        bsViewModal.hide()
    }
    selectedDivisi.value = null
}
</script>
